<template>
  <div class="wrapper deposit-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>{{ $t("CHARGE") }}</h1>
          <div class="tab-area">
            <div
              class="tab link-over"
              v-on:click="isSelect('1')"
              v-bind:class="{ active: isActive === '1' }"
            >
              BTC
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('2')"
              v-bind:class="{ active: isActive === '2' }"
            >
              ETH（ERC20）
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('3')"
              v-bind:class="{ active: isActive === '3' }"
            >
              USDT（BEP20）
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('4')"
              v-bind:class="{ active: isActive === '4' }"
            >
              USDT（TRC20）
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '1'"
            v-bind:class="{ active: isActive === '1' }"
          >
            <div class="balance">
              <div class="address-btn">
                <span class="link-over" v-on:click="toCharge">{{
                  $t("Show wallet address")
                }}</span>
              </div>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '2'"
            v-bind:class="{ active: isActive === '2' }"
          >
            <div class="balance">
              <div class="address-btn">
                <span class="link-over" v-on:click="toCharge">{{
                  $t("Show wallet address")
                }}</span>
              </div>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '3'"
            v-bind:class="{ active: isActive === '3' }"
          >
            <div class="balance">
              <div class="address-btn">
                <span class="link-over" v-on:click="toCharge">{{
                  $t("Show wallet address")
                }}</span>
              </div>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '4'"
            v-bind:class="{ active: isActive === '4' }"
          >
            <div class="balance">
              <div class="address-btn">
                <span class="link-over" v-on:click="toCharge">{{
                  $t("Show wallet address")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <Footer title="Deposit" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Deposit",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Deposit",
      isActive: "1",
    };
  },
  methods: {
    isSelect: function (num) {
      this.isActive = num;
    },
    toCharge() {
      this.$router.push("/deposit2");
    },
  },
  computed: {},
  mounted: function () {},
};
</script>
